interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const buildPages = (page: number, total: number): (number | string)[] => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push("gap-start");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("gap-end");
  pages.push(total);
  return pages;
};

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  const go = (next: number) => {
    if (next < 1 || next > totalPages || next === page) return;
    onChange(next);
  };

  return (
    <nav aria-label="分页导航" className="flex flex-wrap items-center justify-center gap-1.5 mt-8">
      <button
        type="button"
        onClick={() => go(page - 1)}
        disabled={page === 1}
        aria-label="上一页"
        className="h-9 px-3 inline-flex items-center gap-1 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {pages.map((item) =>
        typeof item === "string" ? (
          <span key={item} className="w-9 h-9 hidden sm:flex items-center justify-center text-foreground-400">
            <i className="ri-more-line"></i>
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => go(item)}
            aria-current={item === page ? "page" : undefined}
            className={`w-9 h-9 rounded-md text-sm font-medium transition-colors ${
              item === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {item}
          </button>
        )
      )}
      <button
        type="button"
        onClick={() => go(page + 1)}
        disabled={page === totalPages}
        aria-label="下一页"
        className="h-9 px-3 inline-flex items-center gap-1 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}